import { render, staticRenderFns } from "./CustomerDetailsSetting.vue?vue&type=template&id=03d95db0&scoped=true&"
import script from "./CustomerDetailsSetting.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailsSetting.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetailsSetting.vue?vue&type=style&index=0&id=03d95db0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d95db0",
  null
  
)

export default component.exports